import { useEffect } from "react";
import { isIOSAtom } from "../atoms";

/**
 * Hook to detect iOS devices and store the result in an atom
 * This hook should be called once at the app level
 */
export function useIOSDetection() {
  useEffect(() => {
    const detectIOS = () => {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    };

    const isIOS = detectIOS();
    isIOSAtom.update(isIOS);

    // Also add/remove CSS class for immediate styling
    if (isIOS) {
      document.documentElement.classList.add('is-ios');
    } else {
      document.documentElement.classList.remove('is-ios');
    }
  }, []);

  return isIOSAtom.useValue();
}